import { z } from 'zod'

/** Coerce a `'true'`/`'false'` env string into a boolean. */
const booleanEnv = () =>
  z
    .union([z.literal('true'), z.literal('false')])
    .optional()
    .transform(value => value === 'true')

/**
 * flight-deck-ui's settings. The UI server checks its env against this before it starts, and the
 * browser checks the fetched `runtime-config.json` against it too.
 *
 * Add a key without a default to every Argo values file first, or the server won't start there.
 */
export const FlightDeckEnvSchema = {
  VITE_FLIGHT_DECK_STANDALONE_MODE: z
    .union([z.literal('true'), z.literal('false')])
    .optional()
    .default('false')
    .transform(value => value === 'true'),
  VITE_DISABLE_SOCKET_SERVER: z
    .union([z.literal('true'), z.literal('false')])
    .optional()
    .default('false')
    .transform(value => value === 'true'),
  VITE_EVENTS_API_URL: z.string().url(),
  VITE_FLIGHT_DECK_API_URL: z.string().url(),
  VITE_GARY_GATEWAY_URL: z.string(),
  VITE_MNTN_PASS_URL: z.string().url(),
  VITE_SELECT_URL: z.string().url(),
  VITE_AUTH_API_BASE_URL: z.string().url(),
  VITE_AUTH_ENV: z.union([z.literal('prod'), z.literal('qa'), z.literal('dev')]),
  VITE_AUTH_SPLIT_API_KEY: z.string(),

  /** Grafana Faro - Frontend observability */
  VITE_FARO_ENABLED: booleanEnv(),
  VITE_FARO_COLLECTOR_URL: z.string().url().optional(),
  VITE_FARO_ENVIRONMENT: z.union([z.literal('development'), z.literal('qa'), z.literal('production')]),
}
